'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartUpsellItem = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _themeImages = require('@shopify/theme-images');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var _i18n = require('../../../services/i18n');

var _tracking = require('../../../utils/tracking');

var _functional = require('../../../utils/functional');

var _product = require('../../../utils/product');

var _products = require('../../../services/products');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PushCartUpsellItem = function PushCartUpsellItem(_ref) {
  var variantId = _ref.variantId,
      handle = _ref.handle,
      image = _ref.image,
      title = _ref.title,
      price = _ref.price,
      compareAtPrice = _ref.compareAtPrice,
      vendor = _ref.vendor,
      reviewsRating = _ref.reviewsRating,
      unitPriceMeasurement = _ref.unitPriceMeasurement,
      useNewPushcartDesign = _ref.useNewPushcartDesign;

  var dispatch = (0, _reactRedux.useDispatch)();

  var handleGA4Tracking = (0, _react.useCallback)(function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref3) {
      var eventName = _ref3.eventName,
          quantity = _ref3.quantity;

      var _ref4, product_type, variants, variant, eventGA4;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _products.getProductByHandle)(handle);

            case 3:
              _ref4 = _context.sent;
              product_type = _ref4.product_type;
              variants = _ref4.variants;
              variant = variants[0];
              eventGA4 = new Event(eventName);

              eventGA4.payload = (0, _tracking.setDataLayerItem)({
                product: {
                  title: title,
                  vendor: vendor,
                  product_type: product_type
                },
                variant: {
                  title: variant.title,
                  // eslint-disable-next-line camelcase
                  compare_at_price: String(compareAtPrice / 100),
                  price: String(price / 100),
                  sku: variant.sku
                },
                quantity: quantity
              });
              // eventGA4.payload.context = {
              //   category: 'Mini-Cart',
              //   title: 'Additional Products Upsell',
              // }
              document.dispatchEvent(eventGA4);
              _context.next = 14;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](0);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 12]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [handle]);

  var handleAddToCart = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch((0, _pushCartActions.addItemToCart)({
                id: variantId,
                quantity: 1
              }));

            case 2:
              handleGA4Tracking({ eventName: 'add_to_cart_upsell_mini_cart', quantity: 1 });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function handleAddToCart() {
      return _ref5.apply(this, arguments);
    };
  }();

  return _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Item' }, image && _react2.default.createElement('div', { className: 'prd-AdditionalProducts_ImageContainer' }, _react2.default.createElement('img', { className: 'prd-AdditionalProducts_Image', src: (0, _themeImages.getSizedImageUrl)(image, '200x200') })), _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Content' }, window.theme.isBrandedHouse && _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Details hdn-Xs' }, _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Brand clr-Body' }, vendor), reviewsRating > 1 && _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Reviews clr-Black' }, _react2.default.createElement('span', {
    className: 'prd-AdditionalProducts_Reviews-star ' + (0, _product.getReviewsStarIcon)(reviewsRating)
  }), _react2.default.createElement('span', { className: 'prd-AdditionalProducts_Reviews-rating' }, reviewsRating.toFixed(1)))), _react2.default.createElement('p', { className: 'prd-AdditionalProducts_Title' }, title), _react2.default.createElement('p', { className: 'prd-AdditionalProducts_Price' }, compareAtPrice && _react2.default.createElement('span', { className: 'util-Ma-r2 util-Td-lt' }, (0, _functional.formatMoney)(compareAtPrice)), _react2.default.createElement('span', {
    className: (0, _classnames2.default)({
      'clr-Alert': compareAtPrice
    })
  }, (0, _functional.formatMoney)(price)), _react2.default.createElement('span', { className: 'prd-AdditionalProducts_Tax' }, (0, _i18n.t)('products.product.product_incl_tax'))), unitPriceMeasurement && _react2.default.createElement('p', { className: 'prd-AdditionalProducts_Measurement' }, (0, _product.formatProductPriceMeasurements)(price, unitPriceMeasurement))), _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Actions' }, _react2.default.createElement('span', {
    className: useNewPushcartDesign ? 'prd-AdditionalProducts_Button btn-AutoWidth btn-Secondary btn-FullWidth' : 'prd-AdditionalProducts_Button btn-AutoWidth btn-Tiny btn-FullWidth',
    onClick: function onClick() {
      return handleAddToCart();
    }
  }, (0, _i18n.t)('products.product.additional_product_button'))), useNewPushcartDesign ? _react2.default.createElement('p', { className: 'prd-AdditionalProducts_Badge' }, 'SALE') : null);
};

PushCartUpsellItem.defaultProps = {
  image: null,
  compareAtPrice: null,
  vendor: null,
  reviewsRating: null,
  unitPriceMeasurement: null
};

PushCartUpsellItem.propTypes = {
  variantId: _propTypes2.default.number.isRequired,
  image: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  price: _propTypes2.default.number.isRequired,
  compareAtPrice: _propTypes2.default.number,
  vendor: _propTypes2.default.string,
  reviewsRating: _propTypes2.default.number,
  unitPriceMeasurement: _propTypes2.default.object
};

exports.PushCartUpsellItem = PushCartUpsellItem;